// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 📌 Conteneur principal du carrousel */
.journal-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    width: 100%;
}

/* 📌 Conteneur du carrousel */
.pdf-carousel {
    width: 80%;
    max-width: 900px;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    position: relative;
}

/* 📌 Correction du positionnement des slides */
.slick-list {
    overflow: hidden !important; /* Évite que les éléments disparaissent */
    padding: 20px 0; /* Ajoute un petit espace pour éviter les coupures */
}
/* 🔹 Ajuste la taille du track pour éviter que les éléments dépassent */
.slick-track {
    display: flex !important;
    align-items: center;
    min-height: 400px; /* Ajuste la hauteur du conteneur */
}

/* 📌 Centrage parfait des slides */
.slick-slide {
    display: flex !important;
    justify-content: center;
    align-items: center;
    text-align: center;
    transition: transform 0.3s ease-in-out;
}

/* 📌 Met en valeur l’image centrale */
.slick-center .pdf-item {
    transform: scale(1.2); /* Zoom sur l'élément actif */
    z-index: 10;
    position: relative;
}

/* 📌 Style des items (PDFs) */
.pdf-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center; /* Centre l'élément */
    cursor: pointer;
    transition: transform 0.3s ease-in-out;
    max-width: 150px; /* Évite que les items deviennent trop grands */
}

/* 📌 Effet de survol et d’agrandissement progressif */
.pdf-item.active,
.pdf-item:hover {
    transform: scale(1.1);
}

/* 📌 Style des miniatures */
.pdf-thumbnail {
    width: 150px;
    height: 200px;
    object-fit: cover;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transition: transform 0.3s ease-in-out;
}

/* 📌 Texte sous les miniatures */
.pdf-title {
    margin-top: 10px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    color: #333;
}

/* 📌 Personnalisation des flèches de navigation */
.slick-prev, .slick-next {
    z-index: 20;
    width: 40px;
    height: 40px;
}

.slick-prev::before, .slick-next::before {
    font-size: 30px;
    color: #333; /* Change la couleur des flèches */
    transition: color 0.3s ease-in-out;
}

.slick-prev:hover::before, .slick-next:hover::before {
    color: #007BFF; /* Change la couleur des flèches au survol */
}

/* 📌 Responsive : Ajustement pour mobile */
@media screen and (max-width: 768px) {
    .pdf-carousel {
        width: 100%;
        max-width: 600px;
    }

    .pdf-item {
        max-width: 120px;
    }

    .pdf-thumbnail {
        width: 120px;
        height: 160px;
    }

    .pdf-title {
        font-size: 12px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/composant/container/Journal/Journal.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,WAAW;AACf;;AAEA,8BAA8B;AAC9B;IACI,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA,+CAA+C;AAC/C;IACI,2BAA2B,EAAE,yCAAyC;IACtE,eAAe,EAAE,oDAAoD;AACzE;AACA,wEAAwE;AACxE;IACI,wBAAwB;IACxB,mBAAmB;IACnB,iBAAiB,EAAE,mCAAmC;AAC1D;;AAEA,mCAAmC;AACnC;IACI,wBAAwB;IACxB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA,sCAAsC;AACtC;IACI,qBAAqB,EAAE,6BAA6B;IACpD,WAAW;IACX,kBAAkB;AACtB;;AAEA,8BAA8B;AAC9B;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB,EAAE,qBAAqB;IAC9C,eAAe;IACf,sCAAsC;IACtC,gBAAgB,EAAE,+CAA+C;AACrE;;AAEA,sDAAsD;AACtD;;IAEI,qBAAqB;AACzB;;AAEA,4BAA4B;AAC5B;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,wCAAwC;IACxC,sCAAsC;AAC1C;;AAEA,iCAAiC;AACjC;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;;AAEA,kDAAkD;AAClD;IACI,WAAW;IACX,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,WAAW,EAAE,kCAAkC;IAC/C,kCAAkC;AACtC;;AAEA;IACI,cAAc,EAAE,4CAA4C;AAChE;;AAEA,2CAA2C;AAC3C;IACI;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* 📌 Conteneur principal du carrousel */\n.journal-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 20px;\n    width: 100%;\n}\n\n/* 📌 Conteneur du carrousel */\n.pdf-carousel {\n    width: 80%;\n    max-width: 900px;\n    margin-bottom: 20px;\n    display: flex;\n    justify-content: center;\n    position: relative;\n}\n\n/* 📌 Correction du positionnement des slides */\n.slick-list {\n    overflow: hidden !important; /* Évite que les éléments disparaissent */\n    padding: 20px 0; /* Ajoute un petit espace pour éviter les coupures */\n}\n/* 🔹 Ajuste la taille du track pour éviter que les éléments dépassent */\n.slick-track {\n    display: flex !important;\n    align-items: center;\n    min-height: 400px; /* Ajuste la hauteur du conteneur */\n}\n\n/* 📌 Centrage parfait des slides */\n.slick-slide {\n    display: flex !important;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    transition: transform 0.3s ease-in-out;\n}\n\n/* 📌 Met en valeur l’image centrale */\n.slick-center .pdf-item {\n    transform: scale(1.2); /* Zoom sur l'élément actif */\n    z-index: 10;\n    position: relative;\n}\n\n/* 📌 Style des items (PDFs) */\n.pdf-item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center; /* Centre l'élément */\n    cursor: pointer;\n    transition: transform 0.3s ease-in-out;\n    max-width: 150px; /* Évite que les items deviennent trop grands */\n}\n\n/* 📌 Effet de survol et d’agrandissement progressif */\n.pdf-item.active,\n.pdf-item:hover {\n    transform: scale(1.1);\n}\n\n/* 📌 Style des miniatures */\n.pdf-thumbnail {\n    width: 150px;\n    height: 200px;\n    object-fit: cover;\n    border-radius: 10px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    transition: transform 0.3s ease-in-out;\n}\n\n/* 📌 Texte sous les miniatures */\n.pdf-title {\n    margin-top: 10px;\n    font-size: 14px;\n    font-weight: bold;\n    text-align: center;\n    color: #333;\n}\n\n/* 📌 Personnalisation des flèches de navigation */\n.slick-prev, .slick-next {\n    z-index: 20;\n    width: 40px;\n    height: 40px;\n}\n\n.slick-prev::before, .slick-next::before {\n    font-size: 30px;\n    color: #333; /* Change la couleur des flèches */\n    transition: color 0.3s ease-in-out;\n}\n\n.slick-prev:hover::before, .slick-next:hover::before {\n    color: #007BFF; /* Change la couleur des flèches au survol */\n}\n\n/* 📌 Responsive : Ajustement pour mobile */\n@media screen and (max-width: 768px) {\n    .pdf-carousel {\n        width: 100%;\n        max-width: 600px;\n    }\n\n    .pdf-item {\n        max-width: 120px;\n    }\n\n    .pdf-thumbnail {\n        width: 120px;\n        height: 160px;\n    }\n\n    .pdf-title {\n        font-size: 12px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
